// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  min-width: 400px;
  max-width: 100vw;
  top: 110px;
  bottom: 0;
  left: 0;
  right: 0;
}

@media (max-width: 952px) {
  .wrapper {
    top: 124px;
  }
  .pilot-warning {
    top: 60px;
    padding: 20px;
  }
}
@media (max-width: 575px) {
  .wrapper {
    top: 160px;
  }
  .pilot-warning {
    top: 96px !important;
  }
}
@media (max-width: 522px) {
  .wrapper {
    top: 184px;
  }
}
.pilot-warning {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  min-width: 400px;
  max-width: 100vw;
  z-index: 4;
  top: 60px;
  left: 0;
  right: 0;
  min-height: 50px;
  text-align: justify;
}

/*  */
/*  navbar */
/*  */
.navbar {
  min-width: 400px;
  background-color: #3f51b5;
  color: #fff;
  /* box-shadow: 1px 1px 3px rgba(0,0,0,.1); */
  z-index: 4;
  min-height: 60px;
}

.docs-navbar-header {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: center;
}

.docs-navbar-header > .mat-button:last-child {
  margin-left: auto;
}

.docs-navbar-logo {
  color: #fff;
  text-decoration: none;
}

.admin_sublogo {
  font-size: 65%;
}

.flex-spacer {
  flex-grow: 1;
}

.navbar-divs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
}

/*  */
/* --navbar-- */
/*  */
/*  */
/* sidebar  */
/*  */
.sidenav-container {
  /* When the sidenav is not fixed, stretch the sidenav container to fill the available space. This
     causes \`<mat-sidenav-content>\` to act as our scrolling element for desktop layouts. */
  flex: 1;
}

.is-mobile .sidenav-container {
  /* When the sidenav is fixed, don't constrain the height of the sidenav container. This allows the
     \`<body>\` to be our scrolling element for mobile layouts. */
  flex: 1 0 auto;
}

.sidebar-container {
  min-height: 100%;
}

#sidebar {
  min-width: 230px;
  max-width: 230px;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
  background-color: #fafafa;
  /* background-color: #fafaf1 */
}

.sidebar-municipality {
  margin-top: 8px;
  padding: 0.5rem 0;
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 1.05rem;
}

.mat-nav-list {
  border-bottom: 1px solid #ddd;
  padding-top: 0;
}

.role-header {
  padding: 16px 16px 8px 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-shadow: 4px 4px 6px #aaa;
  text-decoration: underline;
}

.role-subheader {
  padding: 16px 16px 16px 16px;
  letter-spacing: 0.1px;
  text-shadow: 4px 4px 6px #b5b5b5;
  background-color: #fbf9ec;
  border-bottom: #5365c5 solid 2px;
}

.mat-nav-list .mat-list-item {
  height: 56px;
  font-size: 15px;
}

.mat-nav-list .active {
  background-color: #5365c5 !important;
  color: #fff !important;
}

.sidenav-content {
  background-color: #eee;
  padding: 25px 15px;
}

i.material-icons {
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .sidenav-content {
    padding: 25px 0;
  }
}
/*  */
/* --sidebar--  */
/*  */
.matBadgeColor {
  color: #A72925;
}

.mat-badge-content {
  color: white;
  background-color: #A72925;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,UAAA;EAEA,SAAA;EACA,OAAA;EACA,QAAA;AADJ;;AAMA;EACI;IAEI,UAAA;EAJN;EAOE;IACI,SAAA;IACA,aAAA;EALN;AACF;AAUA;EACI;IAGI,UAAA;EAVN;EAeE;IACI,oBAAA;EAbN;AACF;AAkBA;EACI;IAEI,UAAA;EAjBN;AACF;AAsBA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AApBJ;;AAyBA,KAAA;AACA,YAAA;AACA,KAAA;AAEA;EAII,gBAAA;EAEA,yBAAA;EACA,WAAA;EAEA,4CAAA;EACA,UAAA;EACA,gBAAA;AA5BJ;;AAgCA;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AA7BJ;;AAgCA;EACI,iBAAA;AA7BJ;;AAgCA;EACI,WAAA;EACA,qBAAA;AA7BJ;;AAgCA;EACI,cAAA;AA7BJ;;AAiCA;EACI,YAAA;AA9BJ;;AAiCA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA9BJ;;AAmCA,KAAA;AACA,eAAA;AACA,KAAA;AAGA,KAAA;AACA,aAAA;AACA,KAAA;AAEA;EACI;0FAAA;EAEA,OAAA;AAnCJ;;AAsCA;EACI;+DAAA;EAEA,cAAA;AAnCJ;;AAsCA;EACI,gBAAA;AAnCJ;;AAsCA;EACI,gBAAA;EACA,gBAAA;EACA,yHAAA;EACA,yBAAA;EACA,8BAAA;AAnCJ;;AAsCA;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAnCJ;;AAsCA;EACI,6BAAA;EACA,cAAA;AAnCJ;;AAyCA;EACI,2BAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;AAtCJ;;AAyCA;EACI,4BAAA;EAEA,qBAAA;EACA,gCAAA;EACA,yBAAA;EAEA,gCAAA;AAxCJ;;AA2CA;EACI,YAAA;EACA,eAAA;AAxCJ;;AA2CA;EAII,oCAAA;EACA,sBAAA;AA3CJ;;AA8CA;EACI,sBAAA;EACA,kBAAA;AA3CJ;;AA8CA;EACI,oBAAA;AA3CJ;;AAqDA;EACI;IACI,eAAA;EAlDN;AACF;AAoDA,KAAA;AACA,iBAAA;AACA,KAAA;AAGA;EACE,cAAA;AApDF;;AAwDC;EAEC,YAAA;EACA,yBAAA;AAtDF","sourcesContent":[".wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: absolute;\r\n    min-width: 400px;\r\n    max-width: 100vw;\r\n    // top: 60px;\r\n    top: 110px;\r\n\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\n\r\n//To be deleted after pilot\r\n@media (max-width:952px) {\r\n    .wrapper {\r\n        // top: 96px;\r\n        top: calc(60px + 64px)\r\n    }\r\n\r\n    .pilot-warning {\r\n        top: 60px;\r\n        padding: 20px;\r\n    }\r\n}\r\n//\r\n\r\n\r\n@media (max-width:575px) {\r\n    .wrapper {\r\n        // top: 96px;\r\n        //To be deleted after pilot\r\n        top: calc(96px + 64px)\r\n    }\r\n\r\n    //To be deleted after pilot\r\n\r\n    .pilot-warning {\r\n        top: 96px !important;\r\n    }\r\n}\r\n\r\n\r\n//To be deleted after pilot\r\n@media (max-width:522px) {\r\n    .wrapper {\r\n        // top: 96px;\r\n        top: calc(96px + 88px)\r\n    }\r\n}\r\n//\r\n\r\n//To be deleted after pilot\r\n.pilot-warning {\r\n    position: absolute;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 16px;\r\n    min-width: 400px;\r\n    max-width: 100vw;\r\n    z-index: 4;\r\n    top: 60px;\r\n    left: 0;\r\n    right: 0;\r\n    min-height: 50px;\r\n    text-align: justify;\r\n}\r\n//\r\n\r\n\r\n/*  */\r\n/*  navbar */\r\n/*  */\r\n\r\n.navbar {\r\n    // background-color: #37474f;\r\n    // display: flex;\r\n    // align-items: center;\r\n    min-width: 400px;\r\n\r\n    background-color: #3f51b5;\r\n    color:#fff;\r\n    // padding: 0 1.2rem;\r\n    /* box-shadow: 1px 1px 3px rgba(0,0,0,.1); */\r\n    z-index: 4;\r\n    min-height: 60px;\r\n    // height: 50px;\r\n}\r\n\r\n.docs-navbar-header {\r\n    display:flex;\r\n    flex-grow: 1;\r\n    flex-wrap:wrap;\r\n    align-items:center;\r\n}\r\n\r\n.docs-navbar-header > .mat-button:last-child {\r\n    margin-left:auto\r\n}\r\n\r\n.docs-navbar-logo {\r\n    color: #fff;\r\n    text-decoration: none\r\n}\r\n\r\n.admin_sublogo{\r\n    font-size: 65%;\r\n    \r\n}\r\n\r\n.flex-spacer {\r\n    flex-grow:1\r\n}\r\n\r\n.navbar-divs {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 0.5rem;\r\n}\r\n\r\n\r\n\r\n/*  */\r\n/* --navbar-- */\r\n/*  */\r\n\r\n\r\n/*  */\r\n/* sidebar  */\r\n/*  */\r\n\r\n.sidenav-container {\r\n    /* When the sidenav is not fixed, stretch the sidenav container to fill the available space. This\r\n       causes `<mat-sidenav-content>` to act as our scrolling element for desktop layouts. */\r\n    flex: 1;\r\n}\r\n\r\n.is-mobile .sidenav-container {\r\n    /* When the sidenav is fixed, don't constrain the height of the sidenav container. This allows the\r\n       `<body>` to be our scrolling element for mobile layouts. */\r\n    flex: 1 0 auto;\r\n}\r\n\r\n.sidebar-container {\r\n    min-height: 100%;\r\n}\r\n\r\n#sidebar {\r\n    min-width: 230px;\r\n    max-width: 230px;\r\n    box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);\r\n    background-color: #fafafa;\r\n    /* background-color: #fafaf1 */\r\n}\r\n\r\n.sidebar-municipality {\r\n    margin-top: 8px;\r\n    padding: .5rem 0;\r\n    font-weight: bold;\r\n    letter-spacing: 1px;\r\n    font-size: 1.05rem\r\n}\r\n\r\n.mat-nav-list {\r\n    border-bottom: 1px solid #ddd;\r\n    padding-top: 0;\r\n//   background-color: rgba(0, 0, 0, 0.1);\r\n//   margin: 8px 0;\r\n//   height: 1px;\r\n}\r\n\r\n.role-header {\r\n    padding: 16px 16px 8px 16px;\r\n    font-weight: 500;\r\n    letter-spacing: .5px;\r\n    text-shadow: 4px 4px 6px #aaa;\r\n    text-decoration: underline;\r\n}\r\n\r\n.role-subheader {\r\n    padding: 16px 16px 16px 16px;\r\n    // font-weight: 300;\r\n    letter-spacing: 0.1px;\r\n    text-shadow: 4px 4px 6px #b5b5b5;\r\n    background-color: #fbf9ec;\r\n    // border-bottom: 1px solid #ddd;\r\n    border-bottom: #5365c5 solid 2px;\r\n}\r\n\r\n.mat-nav-list .mat-list-item{\r\n    height: 56px;\r\n    font-size: 15px\r\n}\r\n\r\n.mat-nav-list .active{\r\n//   background-color: #37474f;\r\n//   background-color: #3f51b5;\r\n//   background-color: rgba(159, 170, 229, 0.5);\r\n    background-color: #5365c5 !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.sidenav-content {\r\n    background-color: #eee;\r\n    padding: 25px 15px;\r\n}\r\n\r\ni.material-icons {\r\n    margin-right: 0.5rem;\r\n\r\n}\r\n\r\n//   .comp-list-border {\r\n//       background-color: rgba(0, 0, 0, 0.1);\r\n//       margin: 8px 0;\r\n//       height: 1px;\r\n//   }\r\n\r\n@media (max-width:768px) {\r\n    .sidenav-content {\r\n        padding: 25px 0;\r\n    }\r\n}\r\n/*  */\r\n/* --sidebar--  */\r\n/*  */\r\n\r\n\r\n.matBadgeColor{\r\n  color: #A72925;\r\n\r\n}\r\n\r\n .mat-badge-content {\r\n\r\n  color: white;\r\n  background-color: #A72925;\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
